import React, { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { FormElement } from '../../../components/FormElement';
import { LoadingSkeletonTableRows } from '../../../components/LoadingSkeletonTableRows';
import { UserAccount } from '../../../domain/userAccount';
import { useGroupsRepository } from '../../../repository/groups/useGroupsRepository';
import { useAssignGroupsRepository } from '../../../repository/users/useAssignGroupsRepository';
import { useCreateUserRepository, CreateUserData } from '../../../repository/users/useCreateUserRepository';
import { useFindAllUsersRepository } from '../../../repository/users/useFindAllUsersRepository';
import { UserGroupsModal } from './UserGroupsModal';
import { CreateUserModal } from './CreateUserModal';
import { UsersTableRow } from './UsersTableRow';

export const Users = () => {
    const { data: users, isLoading: isLoadingUsers } = useFindAllUsersRepository();
    const { data: groups, isLoading: isLoadingGroups } = useGroupsRepository();
    const { assignGroups } = useAssignGroupsRepository();
    const { createUser } = useCreateUserRepository();

    const [showModal, setShowModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState<UserAccount | undefined>(undefined);

    const handleManageGroups = (user: UserAccount) => {
        setSelectedUser(user);
        setShowModal(true);
    };

    const handleSaveGroups = async (userSub: string, groupIds: string[]) => {
        await assignGroups({ userSub, groupIds });
        toast.success('Grupy użytkownika zostały zaktualizowane');
    };

    const handleCreateUser = async (data: CreateUserData) => {
        await createUser(data);
        toast.success('Użytkownik został utworzony');
    };

    const isLoading = isLoadingUsers || isLoadingGroups;

    return (
        <FormElement
            headingText={
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Użytkownicy</h4>
                    <Button variant="primary" onClick={() => setShowCreateModal(true)}>
                        Dodaj użytkownika
                    </Button>
                </div>
            }
        >
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Imię i nazwisko</th>
                        <th>Email</th>
                        <th>Grupy</th>
                        <th className="text-end">Akcje</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <LoadingSkeletonTableRows rows={3} columns={4} />
                    ) : (
                        users?.map((user) => (
                            <UsersTableRow
                                key={user.sub}
                                user={user}
                                groups={groups || []}
                                onManageGroups={handleManageGroups}
                            />
                        ))
                    )}
                </tbody>
            </Table>
            <UserGroupsModal
                show={showModal}
                user={selectedUser}
                allGroups={groups || []}
                onClose={() => setShowModal(false)}
                onSave={handleSaveGroups}
            />
            <CreateUserModal
                show={showCreateModal}
                allGroups={groups || []}
                onClose={() => setShowCreateModal(false)}
                onSave={handleCreateUser}
            />
        </FormElement>
    );
};
